import React from 'react';
import { useFormContext, useFieldArray } from 'react-hook-form';
import { Button, Grid, Typography } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import Select from '../../select/Select';
import { multiplierOptions } from '../../../../../main/apps/ConfiguredApps/contract-management/contract-creation/wizard/utils';
import FormInput from '../../input/FormInput';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import _ from 'lodash';

const ContractPricingModifier = ({ modifierName }) => {
    const { control } = useFormContext();

    const { fields, append, remove } = useFieldArray({
        control,
        name: modifierName,
    });

    return (
        <Grid sx={{ paddingTop: '10px', borderRadius: '5px', border: '1px solid #e0e0e0', padding: '10px' }}>
            <Typography variant="h6" sx={{ paddingBottom: '10px' }}>
                {`${_.startCase(modifierName.split('_').pop())}`}
            </Typography>
            {fields.map((field, index) => {
                return (
                    <Grid key={field.id} className="mb-16" container spacing={2}>
                        <Grid item xs={3}>
                            <Select name={`${modifierName}.${index}.modifier`} props={{ label: 'Multiplier', required: true, options: multiplierOptions }} />
                        </Grid>
                        <Grid item xs={3}>
                            <FormInput name={`${modifierName}.${index}.amount`} labelKey="Amount" props={{ type: 'number', label: 'Amount', variant: 'outlined', valueAsNumber: true, required: true }} />
                        </Grid>
                        <Grid item xs={3}>
                            <FormInput name={`${modifierName}.${index}.description`} labelKey="Description" props={{ label: 'Description', variant: 'outlined' }} />
                        </Grid>
                        <Grid item xs={1} alignContent="center">
                            <Tooltip title="Delete">
                                <Button onClick={() => remove(index)} color="error">
                                    <DeleteIcon />
                                </Button>
                            </Tooltip>
                        </Grid>
                    </Grid>
                );
            })}
            <Button aria-label="add" startIcon={<AddIcon />} variant="outlined" onClick={() => append({})} sx={{ minWidth: '75%' }}>
                Add
            </Button>
        </Grid>
    );
};

export default ContractPricingModifier;
